import React from "react";
import { RocketOutlined } from "@ant-design/icons";
import styles from "./FirstRunSetup.module.css";

const STEPS = [
  { num: 1, label: "Create\nHub" },
  { num: 2, label: "Create\nBusiness" },
  { num: 3, label: "Publish" },
  { num: 4, label: "Share" },
];

const FirstRunSetup = React.memo(function FirstRunSetup({ onStart }) {
  return (
    <div className={styles.onboarding}>
      <div className={styles.illustration}>
        <RocketOutlined />
      </div>
      <h2 className={styles.title}>Start your business journey</h2>
      <p className={styles.subtitle}>
        Create a hub, add your first business, publish it live, and share it with customers. It only takes a few minutes.
      </p>

      <div className={styles.steps}>
        {STEPS.map((step, idx) => (
          <div key={step.num} className={`${styles.step} ${idx === 0 ? styles.stepActive : ""}`}>
            <div className={styles.stepCircle}>{step.num}</div>
            <span className={styles.stepLabel}>{step.label}</span>
          </div>
        ))}
      </div>

      <button className={styles.startBtn} onClick={onStart}>
        <RocketOutlined /> Get Started
      </button>
    </div>
  );
});

export default FirstRunSetup;
